// Investments.js
import React, { useEffect, useState } from "react";
import "./investments.css";
import "../../common/css/layout.css";
import InvestmentTable from "./InvestmentTable";
import InvestmentForm from "./InvestmentForm";
import InvestmentChart from "../dashboard/InvestmentChart";
import fetchInvestments from '../../common/helpers/InvestmentsHelper';
import { formatCurrency } from '../../common/util/dataFormatterUtils';
import FundSelector from '../components/FundSelector';
import SingleMetric from '../dashboard/SingleMetric';

function Investments() {
    const [data, setData] = useState(null);
    const [editData, setEditData] = useState(null);
    const [selectedFund, setSelectedFund] = useState(null);

    const fetchData = async (fundId) => {
        const investments = await fetchInvestments(fundId);
        setData(investments);
    };

    const handleEdit = (investment) => {
        setEditData({
            fundId: investment.fundId,
            fundName: investment.fundName,
            currentAum: investment.currentAum,
            portcoId: investment.portcoId,
            portcoName: investment.portcoName,
            investmentId: investment.investmentId,
            investmentAmount: investment.investmentAmount,
            investmentDate: investment.investmentDate,
            investmentRoundId: investment.investmentRoundId,
            investmentTypeId: investment.investmentTypeId,
            investmentRound: investment.investmentRound,
            percentOfFundAum: investment.percentOfFundAum,
        });
    }

    const handleClear = () => {
        setEditData(null);
      };
      
    const handleSubmit = () => {
        setEditData(null); // Clear the form after submitting
        fetchData(); // Refetch the data to update the table and chart
    };

    useEffect(() => {
        fetchData(selectedFund ? selectedFund.internal_fund_id : null);
    }, [selectedFund]);

    const onFundSelect = (fund) => {
        setSelectedFund(fund); // Update the state variable with the selected fund
      };

    return(
        <div className="all-components-container">
            <div className="component-no-border component-in-row-2">
                <FundSelector onFundSelect={onFundSelect} enableAllFunds={false}/>
            </div>
            <div className="component-no-border component-in-row-4"></div>
            <div className="component component-in-row-4">
            <SingleMetric metricLabel="Current AUM" metricValue={selectedFund ? formatCurrency(selectedFund.current_aum) : 'N/A'} />
            </div>
            <div className="hr_line"></div>
                <div className="component component-in-row-2">
                    <div className="component-heading">
                        Manage Investment
                    </div>
                    <InvestmentForm onSubmit={handleSubmit} editData={editData} onClear={handleClear}/>
                </div>
                <div className="component component-in-row-2">
                    <div className="component-heading">
                        Investments by Amount
                    </div>
                    {data && <InvestmentChart data={data} />}
                </div>
                <div className="ra__investments_s2-section component-no-border component-in-row-1">
                    {data && <InvestmentTable data={data} onEdit={handleEdit} onDelete={fetchData}/>}
                </div>
        </div>
    );
}

export default Investments;
